module.exports = __webpack_public_path__ + "img/xmark.0febdc9c.svg";